module.exports = __webpack_public_path__ + "img/parent-colors.151d3c2a.svg";